var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "tile h-100" }, [
    _c(
      "div",
      {
        staticClass: "container h-100 mw-100 border-2",
        class: _vm.isSelected ? "selected-tile" : "",
      },
      [
        _c("div", { staticClass: "row bg-white" }, [
          _c(
            "div",
            {
              staticClass: "col-12 bg-header-tile",
              style:
                "background-image: url(" + _vm.offer.backgroundImage + ");",
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm.offer.banner
                  ? _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "tag-timer" }, [
                        _c("div", { staticClass: "row align-items-center" }, [
                          _c("div", { staticClass: "col-auto p-0" }, [
                            _c(
                              "div",
                              { staticClass: "ob1-tag ob1-tag-primary" },
                              [_c("span", [_vm._v(_vm._s(_vm.offer.banner))])]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.offer.timerEndDateInMilliseconds
                            ? _c(
                                "div",
                                { staticClass: "col-auto" },
                                [
                                  _c("timer", {
                                    attrs: {
                                      "end-date-in-milliseconds":
                                        _vm.offer.timerEndDateInMilliseconds,
                                      color: _vm.offer.countDownColor
                                        ? _vm.offer.countDownColor
                                        : "text-dark",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ])
                  : _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "tag-timer" }),
                    ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "pt-1",
                    class: _vm.offer.duoDiscountedPriceConnectedTitle
                      ? "col-12 "
                      : "col-7 pe-0",
                  },
                  [
                    _c("div", [
                      _c("div", { staticClass: "title-align" }, [
                        _c("h2", { staticClass: "visually-hidden" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.offer.name) +
                              "\n                                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "pt-md-1 py-0 mb-0 fw-bold",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.offer.offerType) +
                                "\n                                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.offer.secondaryShortLabel
                          ? _c(
                              "h2",
                              {
                                staticClass: "h1 py-0 mb-0 pb-1",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.offer.secondaryShortLabel) +
                                    "\n                                "
                                ),
                              ]
                            )
                          : _c(
                              "h2",
                              {
                                staticClass: "h4 py-0 mb-0 pb-1",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.offer.name) +
                                    "\n                                "
                                ),
                              ]
                            ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm.priceTitle
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "fw-bold mb-0 pt-0 title-price-align",
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.priceTitle) +
                                    "\n                                "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-5 px-0 pt-1 text-center" }, [
                  _vm.offer.visualUrl
                    ? _c("div", [
                        _c("img", {
                          staticStyle: { "max-width": "120px" },
                          attrs: {
                            width: "100%",
                            alt: _vm.offer.visualAlt,
                            src: _vm.offer.visualUrl,
                          },
                        }),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 pb-1" },
                  [
                    _c("PriceWithDetails", {
                      staticClass: "price-align",
                      attrs: {
                        price: _vm.offer.price,
                        "price-details-popin":
                          _vm.offer.priceDetailsPopin ?? undefined,
                        "offer-id-seo": _vm.offer.offerSeoId,
                        "offer-name": _vm.offer.name,
                        "tracking-category": _vm.priceDetailsTrackingCategory,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "mobileprice-odrmention-align" },
                    [
                      _vm.offer.mobileDiscountedPrice
                        ? _c("AdditionalPrice", {
                            attrs: {
                              title: _vm.offer.mobileDiscountedPriceTitle,
                              "promotion-type":
                                _vm.offer.mobileDiscountedPrice.promotionType,
                              "promotion-duration":
                                _vm.offer.mobileDiscountedPrice.duration,
                              "promotion-price":
                                _vm.offer.mobileDiscountedPrice.price,
                              "initial-price":
                                _vm.offer.mobileDiscountedPrice.initialPrice,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "row list-unstyled mb-0",
                          attrs: { "aria-label": "Offres de remboursement" },
                        },
                        _vm._l(
                          _vm.offer.permanentOdrMentionBlock,
                          function (odr, index) {
                            return _c(
                              "li",
                              { key: index },
                              [
                                _c("InlinePromise", {
                                  attrs: {
                                    claim: { attributes: { textHtml: odr } },
                                    "is-warning": true,
                                    "compact-text": true,
                                  },
                                }),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "cart-item-status-align" },
                    [
                      _vm.offer.addedToCart
                        ? _c("ob1-message-alerte", {
                            attrs: {
                              type: "success",
                              title: _vm.offer.alreadyInCartLabel,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "keywords-align" }, [
                    _vm.offer.keyWords
                      ? _c(
                          "div",
                          [
                            _c("OfferTagsList", {
                              attrs: { "key-words": _vm.offer.keyWords },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 pb-1" }, [
            _c("div", { staticClass: "pt-1 text-center" }, [
              _vm.offer.genericButtonCta
                ? _c(
                    "div",
                    [
                      _c("generic-button-cta", {
                        attrs: {
                          "dto-from-object": _vm.offer.genericButtonCta,
                          "css-classes": "btn-primary w-100 mw-100",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.comparatorCta
              ? _c(
                  "div",
                  { staticClass: "pt-1 text-center" },
                  [
                    _c("generic-button-cta", {
                      attrs: {
                        "dto-from-object": _vm.comparatorCta,
                        "css-classes": "btn-secondary w-100 mw-100",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.offer.genericButtonCta && _vm.offer.selectButton
              ? _c("div", [
                  _vm.isSelected
                    ? _c("div", { staticClass: "internet-selection h-100" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "mb-0 d-flex border-top-bottom-2 align-items-center justify-content-center h-100",
                          },
                          [
                            _c("span", {
                              staticClass: "icon icon-tick-circle",
                              staticStyle: { "font-size": "1.5rem" },
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "lead fw-bold ms-1" }, [
                              _vm._v(_vm._s(_vm.buttonLabel)),
                            ]),
                          ]
                        ),
                      ])
                    : _c("div", { staticClass: "internet-selection" }, [
                        _c(
                          "button",
                          {
                            staticClass: "px-1 px-lg-2 btn btn-secondary w-100",
                            attrs: {
                              type: "button",
                              "data-oevent-category":
                                _vm.offer.selectButtonTms.category,
                              "data-oevent-action":
                                _vm.offer.selectButtonTms.action,
                              "data-oevent-label":
                                _vm.offer.selectButtonTms.label,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onSelectOffer()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.buttonLabel) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 pb-2" }, [
            _c(
              "div",
              {
                staticClass: "detail-link-align d-flex justify-content-center",
              },
              [
                _vm.showDetailPage &&
                _vm.detailPageUrl &&
                _vm.showDetailPageBtnLabel
                  ? _c(
                      "a",
                      {
                        staticClass: "ob1-link-arrow",
                        attrs: {
                          id: "discover-offer-link-" + _vm.offerTileIndex,
                          href: _vm.detailPageUrl,
                          "data-oevent-action":
                            _vm.offer.showOfferDetailPageBtnTms.action,
                          "data-oevent-category":
                            _vm.offer.showOfferDetailPageBtnTms.category,
                          "data-oevent-label":
                            _vm.offer.showOfferDetailPageBtnTms.label,
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.showDetailPageBtnLabel) +
                            "\n                    "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row bg-white" }, [
          _c(
            "div",
            {
              staticClass: "offer-edito-content col-12",
              attrs: {
                "data-oevent-category": _vm.offer.popinTmsDTO.category,
                "data-oevent-label": _vm.offer.popinTmsDTO.label,
              },
            },
            [
              _vm._l(_vm.offer.attributes, function (attribute, index) {
                return _c("div", { key: index }, [
                  attribute.hasTopSeparator
                    ? _c("div", { staticClass: "col-12" }, [
                        _c("hr", { staticClass: "my-0" }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex mb-1" }, [
                    attribute.image
                      ? _c(
                          "div",
                          { staticClass: "offer-tile-attribute-image me-1" },
                          [
                            _c("span", {
                              staticClass: "icon lead text-primary",
                              class: attribute.image,
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", {
                        class: ["font-size-14 media-body-description-" + index],
                        domProps: { innerHTML: _vm._s(attribute.description) },
                      }),
                      _vm._v(" "),
                      attribute.tag
                        ? _c("strong", {
                            staticClass:
                              "ob1-tag ob1-tag-small ob1-tag-specific",
                            domProps: { innerHTML: _vm._s(attribute.tag) },
                          })
                        : _vm._e(),
                    ]),
                  ]),
                ])
              }),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "row list-unstyled",
                  attrs: { "aria-label": "Avantages de l'offre" },
                },
                _vm._l(_vm.offer.claims, function (visualClaim, index) {
                  return _c(
                    "li",
                    { key: `claim-${index}`, staticClass: "col-12 pb-1" },
                    [_c("InlinePromise", { attrs: { claim: visualClaim } })],
                    1
                  )
                }),
                0
              ),
            ],
            2
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }